/**
 * Errors of one field. Crema's pages pass the whole `auth/getErrors` object
 * (`{ deceased: {}, events: [], customer_id: [...] }`), as the former
 * package accepted, while Funeral Manager's inputs expect the field's list.
 */
export function fieldErrors(errors, name) {
  if (Array.isArray(errors)) return errors
  if (!errors || typeof errors !== 'object') return []
  const value = name ? errors[name] : undefined
  if (Array.isArray(value)) return value
  return typeof value === 'string' ? [value] : []
}
